'use strict';

intellidealerAppEquipmentModule.config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state(
    'navigation.equipment.equipmentForSale.equipmentForSaleDetails.hydraulics', {
      url: '/hydraulics',
      templateUrl: 'app/scripts/modules/equipment/views/hydraulics.html'
    }
  );

  $stateProvider.state(
    'public.equipment.equipmentForSale.equipmentForSaleDetails.hydraulics', {
      url: '/hydraulics',
      templateUrl: 'app/scripts/modules/equipment/views/hydraulics.html'
    }
  );
}]);
